var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.get_class},[(_vm.showIcon)?_c('input',{style:(_vm.iconStyle),attrs:{"type":"checkbox","readonly":""},domProps:{"checked":_vm.value}}):_vm._e(),(!_vm.showIcon)?[_vm._v(_vm._s(_vm.display_value))]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }